import { Typography } from "@mui/material";
import { FC } from "react";
import { useQuery } from "react-query";
import { getIpAddress } from "~/services/ip";

interface IpProps {}

const Ip: FC<IpProps> = () => {
  const ipQuery = useQuery({
    queryKey: "ip",
    queryFn: getIpAddress,
  });

  return (
    <div>
      <Typography variant={"h2"}>
        Your Ip address is: {ipQuery?.data?.data?.userIP}
      </Typography>
    </div>
  );
};

export default Ip;
